export interface OnboardingState {
	welcomeShown: boolean
	welcomeCreditsShown: boolean
	intakeSurveyShown: boolean
	unsubscribedSurveyShown: boolean
	createStyleShown: boolean
	calibrationTooltipsShown: number // 0 | 1 | 2
	improveStyleTooltipsShown: number // 0 | 1 | 2
	editingTooltipsShown: number // 0 | 1
	expressSetupTooltipShown: number // 0 | 1
	presetAppliedShown: boolean
	presetAppliedToSuggestedShown: boolean
	colorMatchAppliedToSuggestedShown: boolean
	fullCalibrationTooltipsShown: number // 0 | 1
	markReferenceReminderTooltipShown: number // 0 | 1
	continueReferenceReminderTooltipShown: number // 0 | 1
	adaptiveMaskTooltipShown: number // 0 | 1
	adaptiveHealingTooltipShown: number // 0 | 1
	adaptiveCropTooltipShown: number // 0 | 1
	adaptivePerspectiveTooltipShown: number // 0 | 1
	cullingShown: boolean
	cullingTooltipsShown: number // 0 | 1 | 2 | 3 | 4
	manualCullingTooltipsShown: number // 0 | 1 | 2 | 3
	hiddenPhotosTooltipShown: boolean
	sessionCount: number
}

export const defaultOnboardingState: OnboardingState = {
	welcomeShown: false,
	welcomeCreditsShown: false,
	intakeSurveyShown: false,
	unsubscribedSurveyShown: false,
	createStyleShown: false,
	calibrationTooltipsShown: 0,
	expressSetupTooltipShown: 0,
	improveStyleTooltipsShown: 0,
	editingTooltipsShown: 0,
	presetAppliedShown: false,
	presetAppliedToSuggestedShown: false,
	colorMatchAppliedToSuggestedShown: false,
	fullCalibrationTooltipsShown: 0,
	markReferenceReminderTooltipShown: 0,
	continueReferenceReminderTooltipShown: 0,
	adaptiveMaskTooltipShown: 0,
	adaptiveHealingTooltipShown: 0,
	adaptiveCropTooltipShown: 0,
	adaptivePerspectiveTooltipShown: 0,
	cullingShown: false,
	cullingTooltipsShown: 0,
	manualCullingTooltipsShown: 0,
	hiddenPhotosTooltipShown: false,
	sessionCount: 0,
}
